// import React, { useState, useEffect } from "react";
// import "./TestCreate.css";
// import Papa from "papaparse";
// import Swal from "sweetalert2";
// import { API_BASE_URL } from "../../Config/Config";
// // import ReaderFile from "./FileReader-TS";
// import {useLocation} from "react-router-dom"

// function TestCreate(dataClient) {
  
//   const location = useLocation();
//   // console.log(location.pathname)


//   const [courses, setCourses] = useState([]);
//   const [selectedCourse, setSelectedCourse] = useState("");
//   const [testSeries, setTestSeries] = useState([]);
//   const [selectedSeries, setSelectedSeries] = useState("");
//   const [testDetails, setTestDetails] = useState({
//     mode: "",
//     testDuration: "",
//     questions: "",
//     optionalQuestions: "",
//     testId: "",
//     description: "",
//     numberOfSets: 1,
//     sections: [],
//   });

//   const [error, setError] = useState("");
//   const [currentSubjectIndex, setCurrentSubjectIndex] = useState(null);
//   const [validationErrors, setValidationErrors] = useState([]);
//   const [submitted, setSubmitted] = useState(false);
//   const [subjects, setSubjects] = useState([]);
//   const [selectedSubject, setSelectedSubject] = useState(null);
//   const [chapters, setChapters] = useState([]);
//   const [selectedChapter, setSelectedChapter] = useState(null);
//   const [topics, setTopics] = useState([]);
//   const [selectedTopic, setSelectedTopic] = useState(null);
//   const [allSelections, setAllSelections] = useState([]);
//   const [selectedSet, setSelectedSet] = useState("A");
//   const [uploadedData, setUploadedData] = useState({});
//   const [currentSetQuestions, setCurrentSetQuestions] = useState([]);

//   const [file, setFile] = useState(null);
//   const [optionalQuestionRanges, setOptionalQuestionRanges] = useState([]);
//   const user_name = dataClient.dataClient?.client_schema_name[6][0].user_name;
//   const client_id = dataClient.dataClient?.client_schema_name[6][0].client_id;
//   const client_branch_id =
//     dataClient.dataClient?.client_schema_name[6][0].client_branch_id;

//   const [correctOptionTypeNumeric, setCorrectOptionTypeNumeric] =
//     useState(false);

//   const setMap = { A: "1", B: "2", C: "3", D: "4", E: "5" };

//   const answerMap = {
//     A: 1,
//     B: 2,
//     C: 3,
//     D: 4,
//     E: 5,
//     a: 1,
//     b: 2,
//     c: 3,
//     d: 4,
//     e: 5,
//     0: 0,
//     1: 1,
//     2: 2,
//     3: 3,
//     4: 4,
//     5: 5,
//   };

//   const reverseAnswerMap = {
//     1: "A",
//     2: "B",
//     3: "C",
//     4: "D",
//     5: "E",
//     0: "0",
//   };

//   useEffect(() => {
//     fetch(`${API_BASE_URL}/coaching-collaborator-api/api/v1/get-courses/`)
//       .then((response) => response.json())
//       .then((data) => setCourses(data))
//       .catch((error) => console.error("Error fetching courses:", error));
//   }, []);
//   // console.log("courses",courses)

//   useEffect(() => {
//     if (selectedCourse) {
//       fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-test-series-list-active/?course_id=${selectedCourse}`
//       )
//         .then((response) => response.json())
//         .then((data) => setTestSeries(data.test_series))
//         .catch((error) => console.error("Error fetching test series:", error));
//       fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-subjects-by-course/?course_id=${selectedCourse}`
//       )
//         .then((response) => response.json())
//         .then((data) => setSubjects(data))
//         .catch((error) => console.error("Error fetching subjects:", error));
//     } else {
//       setSubjects([]);
//     }
//   }, [selectedCourse]);

//   useEffect(() => {
//     if (selectedSeries) {
//       fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-test-series-details-by-id/?ts_id=${selectedSeries}`
//       )
//         .then((response) => response.json())

//         .then((data) => {
//           const seriesInfo = data.data;

//           const optionalQuestionsValue = seriesInfo.subjects.some(
//             (subject) => subject.optional_total_count > 0
//           )
//             ? "Yes"
//             : "No";

//           setTestDetails({
//             mode: seriesInfo.test_mode,
//             testDuration: seriesInfo.duration_mins,
//             questions: seriesInfo.total_test_questions,
//             optionalQuestions: optionalQuestionsValue,
//             testId: "",
//             description: "",
//             numberOfSets: 1,
//             sections: seriesInfo.subjects.map((subject) => ({
//               subject_id: subject.subject_id,
//               subject_name: subject.subject_name,
//               mandatory_count: subject.mandatory_count,
//               optional_total_count: subject.optional_total_count,
//               optional_numeric: subject.optional_numeric,
//               from: "",
//               to: "",
//               optionalFrom: "",
//               optionalTo: "",
//             })),
//           });

//           // Set the optional question ranges

//           const ranges = seriesInfo.subjects
//             .map((subject) => ({
//               subject_id: subject.subject_id,
//               optionalFrom: subject.optional_numeric
//                 ? subject.optionalFrom
//                 : null,
//               optionalTo: subject.optional_numeric ? subject.optionalTo : null,
//             }))
//             .filter((subject) => subject.optionalFrom && subject.optionalTo);
//           setOptionalQuestionRanges(ranges);
//         })
//         .catch((error) =>
//           console.error("Error fetching test series details:", error)
//         );
//     }
//   }, [selectedSeries]);

//   useEffect(() => {
//     if (selectedSubject) {
//       fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-chapters-by-subject/?subject_id=${selectedSubject.subject_id}`
//       )
//         .then((response) => response.json())
//         .then((data) => setChapters(data))
//         .catch((error) => console.error("Error fetching chapters:", error));
//     } else {
//       setChapters([]);
//     }
//   }, [selectedSubject]);

//   useEffect(() => {
//     if (selectedChapter) {
//       fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-topics-by-chapter/?chapter_id=${selectedChapter.chapter_id}`
//       )
//         .then((response) => response.json())
//         .then((data) => setTopics(data))
//         .catch((error) => console.error("Error fetching topics:", error));
//     } else {
//       setTopics([]);
//     }
//   }, [selectedChapter]);

//   const handleChange = (e, index, key) => {
//     const value = e.target.value;
//     const input = e.target;
//     input.style.border = "";
//     if (index !== null) {
//       const numericValue = parseInt(value, 10);
//       const newSections = [...testDetails.sections];
//       newSections[index] = {
//         ...newSections[index],
//         [key]: numericValue,
//       };

//       if (key === "to" && testDetails.optionalQuestions === "Yes") {
//         const newOptionalFrom = numericValue + 1;
//         if (
//           !newSections[index].optionalFrom ||
//           newSections[index].optionalFrom <= numericValue
//         ) {
//           newSections[index].optionalFrom = newOptionalFrom;
//         }
//       }

//       setTestDetails((prevDetails) => ({
//         ...prevDetails,
//         sections: newSections,
//       }));

//       const section = newSections[index];

//       if (
//         section.from &&
//         section.to &&
//         (testDetails.optionalQuestions === "No" ||
//           (section.optionalFrom && section.optionalTo))
//       ) {
//         setError("");

//         setCurrentSubjectIndex(null);
//       } else {
//         setCurrentSubjectIndex(index);
//       }
//     } else {
//       setTestDetails((prevDetails) => ({
//         ...prevDetails,

//         [key]: value,
//       }));
//     }
//   };

//   const handleSubjectChange = (event) => {
//     const selected = subjects.find(
//       (subject) => subject.subject_id === parseInt(event.target.value)
//     );
//     setSelectedSubject(selected);
//     setSelectedChapter(null);
//     setChapters([]);
//     setSelectedTopic(null);
//     setTopics([]);
//   };

//   const handleChapterChange = (event) => {
//     const selected = chapters.find(
//       (chapter) => chapter.chapter_id === parseInt(event.target.value)
//     );
//     setSelectedChapter(selected);
//     setSelectedTopic(null);
//     setTopics([]);
//   };

//   const handleTopicChange = (event) => {
//     const selected = topics.find(
//       (topic) => topic.topic_id === parseInt(event.target.value)
//     );
//     setSelectedTopic(selected);
//   };

//   const handleAddSelection = () => {
//     const newSelection = {
//       subject: selectedSubject,
//       chapter: selectedChapter,
//       topic: selectedTopic,
//     };

//     setAllSelections([...allSelections, newSelection]);
//     setSelectedChapter(null);
//     setChapters([]);
//     setSelectedTopic(null);
//     setTopics([]);
//   };

//   const removeSelection = (index, level) => {
//     const updatedSelections = [...allSelections];

//     if (level === "subject") {
//       updatedSelections.splice(index, 1);
//     } else if (level === "chapter") {
//       updatedSelections[index] = {
//         ...updatedSelections[index],
//         chapter: null,
//         topic: null,
//       };
//     } else if (level === "topic") {
//       updatedSelections[index] = { ...updatedSelections[index], topic: null };
//     }
//     setAllSelections(updatedSelections);
//   };

//   const handleFileChange = (event) => {
//     setFile(event.target.files[0]);
//   };

//   // const handleUpload = () => {
//   //   if (!file) {
//   //     console.error("No file selected!");
//   //     return;
//   //   }
//   //   if (!selectedSet) {
//   //     console.error("No set selected!");
//   //     return;
//   //   }
//   //   // console.log("Starting file upload...");
//   //   Papa.parse(file, {
//   //     header: true,
//   //     skipEmptyLines: true,
//   //     complete: function (results) {
//   //       if (results.errors.length) {
//   //         console.error("Errors parsing CSV:", results.errors);
//   //         return;
//   //       }

//   //       const data = results.data;
//   //       // console.log(isNaN(data[0].Key))
//   //       if (!isNaN(data[0].Key)) {
//   //         setCorrectOptionTypeNumeric(true);
//   //         // console.log("Type",correctOptionTypeNumeric)
//   //       }

//   //       // console.log(isNaN(data[0]["Key "]))
//   //       const formattedData = data.map((item, index) => {
//   //         const keys = Object.keys(item);
//   //         const question = item[keys[0]];
//   //         const correct_ans = item[keys[1]];
//   //         const numeric = item[keys[2]];

//   //         const answers = correct_ans
//   //           ? correct_ans.split(/[,|]/).map((ans) => ans.trim())
//   //           : ["0"];

//   //         let numeric_answer =
//   //           numeric !== undefined && numeric !== null ? numeric : null;
//   //         // console.log("answer",answers)

//   //         let correct_option = answers.map((answer) => {
//   //           // console.log("answer",isNaN(answer))
//   //           if (answerMap[answer] !== undefined) {
//   //             return answerMap[answer];
//   //           } else if (!isNaN(answer)) {
//   //             return parseInt(answer, 10); // Ensure number format is handled
//   //           } else {
//   //             return 0;
//   //           }
//   //         });

//   //         if (numeric_answer !== null) {
//   //           numeric_answer = numeric_answer
//   //             .replace(/^0+([1-9])/, "$1")
//   //             .replace(/^0+([.])/, "$1")
//   //             .replace(/^0+(\.\d+)/, "$1");
//   //         }

//   //         if (numeric_answer === null && correct_option.includes(0)) {
//   //           numeric_answer = "0";
//   //         }

//   //         return {
//   //           set: selectedSet,
//   //           question_no: index + 1,
//   //           correct_option:
//   //             correct_option.length > 0 ? correct_option.map(Number) : [0],
//   //           numeric_answer: numeric_answer ? numeric_answer : null,
//   //         };
//   //       });

//   //       setUploadedData((prev) => ({
//   //         ...prev,
//   //         [selectedSet]: formattedData,
//   //         ques_ans_details: [
//   //           ...(prev.ques_ans_details || []),
//   //           ...formattedData,
//   //         ],
//   //       }));
//   //     },
//   //   });
//   // };

//   const handleUpload = () => {
//     if (!file) {
//       console.error("No file selected!");
//       return;
//     }
//     if (!selectedSet) {
//       console.error("No set selected!");
//       return;
//     }

//     Papa.parse(file, {
//       header: true,
//       skipEmptyLines: true,
//       complete: function (results) {
//         if (results.errors.length) {
//           console.error("Errors parsing CSV:", results.errors);
//           return;
//         }

//         const data = results.data;
//         if (!isNaN(data[0].Key)) {
//           setCorrectOptionTypeNumeric(true);
//         }

//         const formattedData = data.map((item, index) => {
//           const keys = Object.keys(item);
//           const question = item[keys[0]];
//           const correct_ans = item[keys[1]];
//           const numeric = item[keys[2]];

//           const answers = correct_ans
//             ? correct_ans.split(/[,|]/).map((ans) => ans.trim())
//             : ["0"];

//           let numeric_answer =
//             numeric !== undefined && numeric !== null ? numeric : null;

//           let correct_option = answers.map((answer) => {
//             if (answerMap[answer] !== undefined) {
//               return answerMap[answer];
//             } else if (!isNaN(answer)) {
//               return parseInt(answer, 10); // Ensure number format is handled
//             } else {
//               return 0;
//             }
//           });

//           if (numeric_answer !== null) {
//             numeric_answer = numeric_answer
//               .replace(/^0+([1-9])/, "$1")
//               .replace(/^0+([.])/, "$1")
//               .replace(/^0+(\.\d+)/, "$1");
//           }

//           if (numeric_answer === null && correct_option.includes(0)) {
//             numeric_answer = "0";
//           }

//           return {
//             set: selectedSet,
//             question_no: index + 1,
//             correct_option:
//               correct_option.length > 0 ? correct_option.map(Number) : [0],
//             numeric_answer: numeric_answer ? numeric_answer : null,
//           };
//         });

//         setUploadedData((prev) => ({
//           ...prev,
//           [selectedSet]: formattedData,
//           ques_ans_details: [
//             ...(prev.ques_ans_details || []),
//             ...formattedData,
//           ],
//         }));

//         setCurrentSetQuestions(formattedData);
//       },
//     });
//   };

//   const handleSetChange = (event) => {
//     const newSelectedSet = event.target.value;
//     setSelectedSet(newSelectedSet);

//     if (uploadedData[newSelectedSet]) {
//       setCurrentSetQuestions(uploadedData[newSelectedSet]);
//     } else {
//       setCurrentSetQuestions([]);
//     }
//   };

//   const   handleCreate = async (e) => {
//     e.preventDefault();

//     if (!testDetails.testId) {
//       Swal.fire({
//         title: "Error",
//         text: "Enter Test Name",
//         icon: "error",
//         confirmButtonColor: "rgb(100 101 101)",
//       });

//       return;
//     }

//     if (!testDetails.description) {
//       Swal.fire({
//         title: "Error",
//         text: "Enter Description",
//         icon: "error",
//         confirmButtonColor: "rgb(100 101 101)",
//       });
//       return;
//     }

//     if (
//       Object.keys(uploadedData).length === 0 ||
//       !uploadedData.ques_ans_details
//     ) {
//       Swal.fire({
//         title: "Error",
//         text: "Upload the answer key file",
//         icon: "error",
//         confirmButtonColor: "rgb(100 101 101)",
//       });
//       return;
//     }

//     const totalQuestions = parseInt(testDetails.questions, 10);

//     const sets = Object.keys(uploadedData).filter(
//       (key) => key !== "ques_ans_details"
//     );

//     for (let set of sets) {
//       if (uploadedData[set].length !== totalQuestions) {
//         Swal.fire({
//           title: "Error",
//           text: "No of questions in answer key does not match Total Questions",
//           icon: "error",
//           confirmButtonColor: "rgb(100 101 101)",
//         });
//         return;
//       }
//     }

//     const expectedSets = Array.from(
//       { length: testDetails.numberOfSets },
//       (_, i) => String.fromCharCode(65 + i)
//     );

//     const missingSets = expectedSets.filter(
//       (set) => !uploadedData.hasOwnProperty(set)
//     );

//     if (missingSets.length > 0) {
//       Swal.fire({
//         title: "Error",
//         text: `Upload answer key files for the following sets: ${missingSets.join(
//           ", "
//         )}`,
//         icon: "error",
//         confirmButtonColor: "rgb(100 101 101)",
//       });
//       return;
//     }

//     setSubmitted(true);

//     let pairs = [];

//     testDetails.sections.forEach((section, index) => {
//       if (section.from && section.to) {
//         pairs.push({
//           from: section.from,
//           to: section.to,
//           fieldFrom: document.querySelector(`#subject-${index} .from`),
//           fieldTo: document.querySelector(`#subject-${index} .to`),
//         });
//       }

//       if (
//         section.optionalFrom &&
//         section.optionalTo &&
//         testDetails.optionalQuestions === "Yes"
//       ) {
//         pairs.push({
//           from: section.optionalFrom,
//           to: section.optionalTo,
//           fieldFrom: document.querySelector(`#subject-${index} .optionalFrom`),
//           fieldTo: document.querySelector(`#subject-${index} .optionalTo`),
//         });
//       }
//     });

//     pairs.sort((a, b) => a.from - b.from);

//     let validPairs = true;

//     for (let i = 0; i < pairs.length - 1; i++) {
//       const currentTo = pairs[i].to;
//       const nextFrom = pairs[i + 1].from;
//       if (nextFrom - currentTo !== 1) {
//         validPairs = false;
//         pairs[i + 1].fieldFrom.style.border = "2px solid red";
//       }
//     }

//     if (!validPairs) {
//       setError("The difference between consecutive pairs should be 1.");
//       return;
//     } else {
//       setError("");
//     }

//     const sectionsWithTotals = testDetails.sections.map((section) => ({
//       ...section,
//       totalSectionA: calculateTotal(section.from, section.to),
//       totalSectionB:
//         testDetails.optionalQuestions === "Yes"
//           ? calculateTotal(section.optionalFrom, section.optionalTo)
//           : 0,
//     }));

//     validateSections(sectionsWithTotals);
//     if (validationErrors.length > 0) {
//       return;
//     }

//     const totalQuestionsFromSections = sectionsWithTotals.reduce(
//       (acc, section) => acc + section.totalSectionA + section.totalSectionB,
//       0
//     );

//     if (totalQuestionsFromSections !== parseInt(testDetails.questions, 10)) {
//       setError(
//         `The sum of all Total A + B (${totalQuestionsFromSections}) must equal the Total Questions (${testDetails.questions}).`
//       );
//       return;
//     }

//     const subjectTopicDetails = allSelections.map((selection) => ({
//       subject_id: selection.subject.subject_id,
//       chapter_id: selection.chapter ? selection.chapter.chapter_id : 0,
//       topic_id: selection.topic ? selection.topic.topic_id : 0,
//       subtopic_id: null,
//     }));

//     // const subjectQuestionDetails = sectionsWithTotals.map((section) => ({
//     //   subject_id: section.subject_id,
//     //   mandatory_from: section.from,
//     //   mandatory_to: section.to,
//     //   optional_from: section.optionalFrom || 0,
//     //   optional_to: section.optionalTo || 0,
//     // }));
//     const prepareSubjectQuestionDetails = (sections) => {
//       return sections.map((section) => ({
//         subject_id: section.subject_id,
//         mandatory_from: section.from ? parseInt(section.from, 10) : 0, // Ensure integer
//         mandatory_to: section.to ? parseInt(section.to, 10) : 0, // Ensure integer
//         optional_from: section.optionalFrom ? parseInt(section.optionalFrom, 10) : 0, // Ensure integer
//         optional_to: section.optionalTo ? parseInt(section.optionalTo, 10) : 0, // Ensure integer
//       }));
//     };
    
//     // Usage
//     const subjectQuestionDetails = prepareSubjectQuestionDetails(testDetails.sections);
    

//     let quesAnsDetails = [];

//     for (let set in uploadedData) {
//       if (set !== "ques_ans_details") {
//         const setData = uploadedData[set].map((item) => ({
//           set: setMap[set],
//           question_no: parseInt(item.question_no),
//           correct_option: item.correct_option,
//           numeric_answer: item.numeric_answer,
//         }));
//         quesAnsDetails = quesAnsDetails.concat(setData);
//       }
//     }

//     const outputData = {
//       subject_topic_details: subjectTopicDetails,
//       subject_question_details: subjectQuestionDetails,
//       ques_ans_details: quesAnsDetails,
//     };

//     console.log(quesAnsDetails);

//     const url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/create-test?assessment_name=${testDetails.testId}&course_id=${selectedCourse}&ts_id=${selectedSeries}&no_of_sets=${testDetails.numberOfSets}&user_name=${user_name}&client_id=${client_id}&client_branch_id=${client_branch_id}&assessment_desc=${testDetails.description}`;

//     try {
//       const response = await fetch(url, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(outputData),
//       });

//       const data = await response.json();

//       if (response.ok) {
//         Swal.fire({
//           title: "Test created successfully",
//           // text: data.message,
//           icon: "success",
//           timer: 2000,
//           confirmButtonColor: "#318682",
//         }).then(() => {
//           setTimeout(() => {
//             window.location.reload();
//           }, 100);
//         });
//       } else {
//         Swal.fire({
//           title: "Error in creating test",
//           text: data.message,
//           icon: "error",
//           confirmButtonColor: "rgb(100 101 101)",
//         });
//       }
//     } catch (error) {
//       console.error("Error creating test:", error);

//       Swal.fire({
//         title: "Error in creating test",
//         text: `${error.message}`,
//         icon: "error",
//         confirmButtonColor: "rgb(100 101 101)",
//       });
//     }
//   };

//   const handleCancel = () => {
//     Swal.fire({
//       title: "Are you sure you want to cancel?",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonText: "Yes",
//       cancelButtonText: "No",
//       confirmButtonColor: "rgb(100 101 101)",
//       cancelButtonColor: "#318682",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         window.location.reload();
//       }
//     });
//   };

//   // const calculateTotal = (from, to) => {
//   //   return Math.max(0, (parseInt(to, 10) || 0) - (parseInt(from, 10) || 0) + 1);
//   // };

//   const calculateTotal = (from, to) => {
//   if (!from || !to) return 0; // Return 0 if either value is null, undefined, or 0
//   return Math.max(0, (parseInt(to, 10) || 0) - (parseInt(from, 10) || 0) + 1);
// };

//   const getMinValue = (index, key) => {
//     if (key === "to" && testDetails.sections[index].from) {
//       return parseInt(testDetails.sections[index].from, 10) + 1;
//     }

//     if (key === "optionalFrom" && testDetails.sections[index].to) {
//       return parseInt(testDetails.sections[index].to, 10) + 1;
//     }

//     if (key === "optionalTo" && testDetails.sections[index].optionalFrom) {
//       return parseInt(testDetails.sections[index].optionalFrom, 10) + 1;
//     }

//     return 0;
//   };

//   // const validateSections = (sections) => {
//   //   let errors = [];

//   //   sections.forEach((section, index) => {
//   //     const totalSectionA = calculateTotal(section.from, section.to);

//   //     const totalSectionB =
//   //       testDetails.optionalQuestions === "Yes"
//   //         ? calculateTotal(section.optionalFrom, section.optionalTo)
//   //         : 0;

//   //     if (totalSectionA !== section.mandatory_count) {
//   //       errors.push({
//   //         subjectName: section.subject_name,
//   //         message: `Total Section A value should be ${section.mandatory_count} for ${section.subject_name}`,
//   //         field: `sectionA-${index}`,
//   //       });
//   //     }

//   //     if (totalSectionB !== section.optional_total_count) {
//   //       errors.push({
//   //         subjectName: section.subject_name,
//   //         message: `Total Section B value should be ${section.optional_total_count} for ${section.subject_name}`,
//   //         field: `sectionB-${index}`,
//   //       });
//   //     }
//   //   });

//   //   setValidationErrors(errors);

//   //   setError(errors.length > 0 ? errors[0].message : "");
//   // };













// //   const validateSections = (sections) => {
// //   let errors = [];

// //   sections.forEach((section, index) => {
// //     // Skip validation for subjects with no questions
// //     if (!section.from && !section.to && !section.optionalFrom && !section.optionalTo) {
// //       return;
// //     }

// //     const totalSectionA = calculateTotal(section.from, section.to);

// //     const totalSectionB =
// //       testDetails.optionalQuestions === "Yes"
// //         ? calculateTotal(section.optionalFrom, section.optionalTo)
// //         : 0;

// //     if (totalSectionA !== section.mandatory_count) {
// //       errors.push({
// //         subjectName: section.subject_name,
// //         message: `Total Section A value should be ${section.mandatory_count} for ${section.subject_name}`,
// //         field: `sectionA-${index}`,
// //       });
// //     }

// //     if (totalSectionB !== section.optional_total_count) {
// //       errors.push({
// //         subjectName: section.subject_name,
// //         message: `Total Section B value should be ${section.optional_total_count} for ${section.subject_name}`,
// //         field: `sectionB-${index}`,
// //       });
// //     }
// //   });

// //   setValidationErrors(errors);
// //   setError(errors.length > 0 ? errors[0].message : "");
// // };










// const validateSections = (sections) => {
//   let errors = [];
//   let totalQuestionsCount = 0;

//   sections.forEach((section, index) => {
//     // Skip subjects with no questions defined
//     if (!section.from && !section.to && !section.optionalFrom && !section.optionalTo) {
//       return;
//     }

//     const totalSectionA = calculateTotal(section.from, section.to);
//     const totalSectionB =
//       testDetails.optionalQuestions === "Yes"
//         ? calculateTotal(section.optionalFrom, section.optionalTo)
//         : 0;

//     totalQuestionsCount += totalSectionA + totalSectionB;

//     // Validation for Section A
//     if (totalSectionA !== section.mandatory_count) {
//       errors.push({
//         subjectName: section.subject_name,
//         message: `Total Section A value should be ${section.mandatory_count} for ${section.subject_name}`,
//         field: `sectionA-${index}`,
//       });
//     }

//     // Validation for Section B
//     if (totalSectionB !== section.optional_total_count) {
//       errors.push({
//         subjectName: section.subject_name,
//         message: `Total Section B value should be ${section.optional_total_count} for ${section.subject_name}`,
//         field: `sectionB-${index}`,
//       });
//     }
//   });

//   if (totalQuestionsCount !== parseInt(testDetails.questions, 10)) {
//     errors.push({
//       message: `The sum of all Total A + B (${totalQuestionsCount}) must equal the Total Questions (${testDetails.questions}).`,
//     });
//   }

//   setValidationErrors(errors);
//   setError(errors.length > 0 ? errors[0].message : "");
// };




//   return (
//     <>
//       <div className="create-role-container">
//         <div className="create-role-container-one">
//           <span className="create-role-heading">Create Test</span>

//           <div className="cr-header-btn-container">
//             <button className="cr-cancel-btn" onClick={handleCancel}>
//               CANCEL
//             </button>

//             <button className="cr-create-btn" onClick={handleCreate}>
//               CREATE
//             </button>
//           </div>
//         </div>

//         <div className="create-role-container-two">
//           <form>
//             <h3 className="tscr-heading">TEST PARTICULARS</h3>

//             <div className="tscr-bodies tscr-grid-container">
//               <label className="tscr-grid-item">Course:</label>

//               <select
//                 name="course"
//                 value={selectedCourse}
//                 onChange={(e) => {setSelectedCourse(e.target.value)}}
//                 className="tscr-grid-item"
//               >
//                 <option value="">Select a course</option>

//                 {courses.map((course) => (
//                   <option key={course.course_id} value={course.course_id}>
//                     {course.course_name}
//                   </option>
//                 ))}
//               </select>

//               <label className="tscr-grid-item">Test Series:</label>

//               <select
//                 name="testSeries"
//                 value={selectedSeries}
//                 onChange={(e) => setSelectedSeries(e.target.value)}
//                 disabled={!selectedCourse}
//                 className="tscr-grid-item"
//               >
//                 <option value="">Select a series</option>

//                 {testSeries.map((series) => (
//                   <option key={series.ts_id} value={series.ts_id}>
//                     {series.ts_name}
//                   </option>
//                 ))}
//               </select>

//               <label className="tscr-grid-item">Mode:</label>

//               <input
//                 className="tscr-grid-item"
//                 name="mode"
//                 value={testDetails.mode}
//                 readOnly
//                 style={{ backgroundColor: "lightgray", border: "none" }}
//               />

//               <label className="tscr-grid-item">Test Duration (mins):</label>

//               <input
//                 className="tscr-grid-item"
//                 name="testDuration"
//                 value={testDetails.testDuration}
//                 readOnly
//                 style={{ backgroundColor: "lightgray", border: "none" }}
//               />

//               <label className="tscr-grid-item">Total Questions:</label>

//               <input
//                 className="tscr-grid-item"
//                 name="questions"
//                 value={testDetails.questions}
//                 readOnly
//                 style={{ backgroundColor: "lightgray", border: "none" }}
//               />

//               <label className="tscr-grid-item">Optional Questions:</label>

//               <input
//                 className="tscr-grid-item"
//                 name="optionalQuestions"
//                 value={testDetails.optionalQuestions}
//                 readOnly
//                 style={{ backgroundColor: "lightgray", border: "none" }}
//               />

//               <label className="tscr-grid-item">Test Name:</label>
//               {/* <input
//                 className="tscr-grid-item"
//                 name="testId"
//                 type="text"
//                 value={testDetails.testId}
//                 onChange={(e) => handleChange(e, null, "testId")}
//               /> */}
//               <input
//                 className="tscr-grid-item"
//                 name="testId"
//                 type="text"
//                 value={testDetails.testId}
//                 onChange={(e) => {
//                   setTestDetails((prevDetails) => ({
//                     ...prevDetails,
//                     testId: e.target.value, // Update state with the raw value (including spaces)
//                   }));
//                 }}
//                 onBlur={(e) => {
//                   const trimmedValue = e.target.value.trim(); // Trim spaces on blur (when the input loses focus)
//                   setTestDetails((prevDetails) => ({
//                     ...prevDetails,
//                     testId: trimmedValue,
//                   }));
//                 }}
//               />


//               <label className="tscr-grid-item">Description:</label>

//               <input
//                 className="tscr-grid-item"
//                 name="description"
//                 value={testDetails.description}
//                 onChange={(e) => handleChange(e, null, "description")}
//               />

//               <label className="tscr-grid-item">Number of Sets:</label>

//               <select
//                 className="tscr-grid-item"
//                 name="numberOfSets"
//                 value={testDetails.numberOfSets}
//                 onChange={(e) => handleChange(e, null, "numberOfSets")}
//               >
//                 {[1, 2, 3, 4, 5].map((num) => (
//                   <option key={num} value={num}>
//                     {num}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* SUBJECT TAGGING */}

//             <div>
//               <h3 className="tscr-heading">TEST PAPER TAGGING</h3>

//               <div className="tpt-container tscr-bodies">
//                 <div className="tpt-dropdowns">
//                   <div className="tpt-dropdowns-content">
//                     <label>
//                       <label className="categoryname-TSCR">Subject:</label>

//                       <select
//                         value={
//                           selectedSubject ? selectedSubject.subject_id : ""
//                         }
//                         onChange={handleSubjectChange}
//                         disabled={!selectedCourse}
//                       >
//                         <option value="">Select Subject</option>

//                         {subjects.map((subject) => (
//                           <option
//                             key={subject.subject_id}
//                             value={subject.subject_id}
//                           >
//                             {subject.subject_name}
//                           </option>
//                         ))}
//                       </select>
//                     </label>

//                     <label>
//                       <label className="categoryname-TSCR"> Chapter:</label>

//                       <select
//                         value={
//                           selectedChapter ? selectedChapter.chapter_id : ""
//                         }
//                         onChange={handleChapterChange}
//                         disabled={!selectedSubject}
//                       >
//                         <option value="">Select Chapter</option>

//                         {selectedSubject &&
//                           chapters.map((chapter) => (
//                             <option
//                               key={chapter.chapter_id}
//                               value={chapter.chapter_id}
//                             >
//                               {chapter.chapter_name}
//                             </option>
//                           ))}
//                       </select>
//                     </label>

//                     <label>
//                       <label className="categoryname-TSCR"> Topic:</label>

//                       <select
//                         value={selectedTopic ? selectedTopic.topic_id : ""}
//                         onChange={handleTopicChange}
//                         disabled={!selectedChapter}
//                       >
//                         <option value="">Select Topic</option>

//                         {selectedChapter &&
//                           topics.map((topic) => (
//                             <option key={topic.topic_id} value={topic.topic_id}>
//                               {topic.topic_name}
//                             </option>
//                           ))}
//                       </select>
//                     </label>

//                     <div className="tpt-addbtn-cont">
//                       <button
//                         type="button"
//                         onClick={handleAddSelection}
//                         disabled={!selectedChapter}
//                         className="tscr-Add-TSCR"
//                       >
//                         Add
//                       </button>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="tpt-tags">
//                   <h4>Selections</h4>

//                   {allSelections.map((selection, index) => (
//                     <div key={index}>
//                       {/* Subject: {selection.subject.subject_name} */}

//                       {selection.subject.subject_name}

//                       <button
//                         type="button"
//                         onClick={() => removeSelection(index, "subject")}
//                       >
//                         &#x2716;
//                       </button>

//                       {selection.chapter && (
//                         <>
//                           {/* &gt; Chapter: {selection.chapter.chapter_name} */}
//                           <span style={{ fontSize: "20px" }}>
//                             &#x276F;
//                           </span>{" "}
//                           {selection.chapter.chapter_name}
//                           <button
//                             type="button"
//                             onClick={() => removeSelection(index, "chapter")}
//                           >
//                             &#x2716;
//                           </button>
//                         </>
//                       )}

//                       {selection.topic && (
//                         <>
//                           {/* &gt; Topic: {selection.topic.topic_name} */}
//                           <span style={{ fontSize: "20px" }}>
//                             &#x276F;
//                           </span>{" "}
//                           {selection.topic.topic_name}
//                           <button
//                             type="button"
//                             onClick={() => removeSelection(index, "topic")}
//                           >
//                             &#x2716;
//                           </button>
//                         </>
//                       )}
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>

//             {selectedSeries && (
//               <>
//                 <h3 className="tscr-heading">TEST PAPER STRUCTURE</h3>

//                 <div className="tscr-testpaperstr tscr-bodies">
//                   {submitted && error && (
//                     <div style={{ color: "red", marginBottom: "10px" }}>
//                       {error}
//                     </div>
//                   )}

//                   <table>
//                     <thead>
//                       <tr>
//                         <th colSpan="1">{""}</th>
//                         <th colSpan="3">Mandatory Q (Section A)</th>
//                         <th colSpan="3">Optional Q (Section B)</th>
//                         <th colSpan="1">Total</th>
//                       </tr>

//                       <tr>
//                         <td>Subject</td>
//                         <td>From</td>
//                         <td>To</td>
//                         <td>Total Section A</td>
//                         <td>Optional From</td>
//                         <td>Optional To</td>
//                         <td>Total Section B</td>
//                         <td>Total A + B</td>
//                       </tr>
//                     </thead>

//                     <tbody>
//                       {testDetails.sections.map((section, index) => (
//                         <React.Fragment key={index}>
//                           <tr id={`subject-${index}`}>
//                             <td>{section.subject_name}</td>

//                             <td>
//                               <input
//                                 className="from"
//                                 value={section.from}
//                                 onChange={(e) => handleChange(e, index, "from")}
//                                 type="number"
//                                 min={getMinValue(index, "from")}
//                                 disabled={
//                                   currentSubjectIndex !== null &&
//                                   currentSubjectIndex !== index
//                                 }
//                               />
//                             </td>

//                             <td>
//                               <input
//                                 className="to"
//                                 value={section.to}
//                                 onChange={(e) => handleChange(e, index, "to")}
//                                 type="number"
//                                 min={getMinValue(index, "to")}
//                                 disabled={
//                                   currentSubjectIndex !== null &&
//                                   currentSubjectIndex !== index
//                                 }
//                               />
//                             </td>

//                             <td>
//                               <div
//                                 className={
//                                   submitted &&
//                                   validationErrors.some(
//                                     (error) =>
//                                       error.field === `sectionA-${index}`
//                                   )
//                                     ? "tscr-error"
//                                     : ""
//                                 }
//                               >
//                                 {section.from && section.to
//                                   ? calculateTotal(section.from, section.to)
//                                   : 0}
//                               </div>
//                             </td>

//                             <td>
//                               <input
//                                 className="optionalFrom"
//                                 value={section.optionalFrom}
//                                 onChange={(e) =>
//                                   handleChange(e, index, "optionalFrom")
//                                 }
//                                 type="number"
//                                 min={getMinValue(index, "optionalFrom")}
//                                 disabled={
//                                   testDetails.optionalQuestions === "No" ||
//                                   (currentSubjectIndex !== null &&
//                                     currentSubjectIndex !== index)
//                                 }
//                               />
//                             </td>

//                             <td>
//                               <input
//                                 className="optionalTo"
//                                 value={section.optionalTo}
//                                 onChange={(e) =>
//                                   handleChange(e, index, "optionalTo")
//                                 }
//                                 type="number"
//                                 min={getMinValue(index, "optionalTo")}
//                                 disabled={
//                                   testDetails.optionalQuestions === "No" ||
//                                   (currentSubjectIndex !== null &&
//                                     currentSubjectIndex !== index)
//                                 }
//                               />
//                             </td>

//                             <td>
//                               <div
//                                 className={
//                                   submitted &&
//                                   validationErrors.some(
//                                     (error) =>
//                                       error.field === `sectionB-${index}`
//                                   )
//                                     ? "tscr-error"
//                                     : ""
//                                 }
//                               >
//                                 {section.optionalFrom && section.optionalTo
//                                   ? calculateTotal(
//                                       section.optionalFrom,

//                                       section.optionalTo
//                                     )
//                                   : 0}
//                               </div>
//                             </td>

//                             <td>
//                               {(section.from && section.to
//                                 ? calculateTotal(section.from, section.to)
//                                 : 0) +
//                                 (section.optionalFrom && section.optionalTo
//                                   ? calculateTotal(
//                                       section.optionalFrom,

//                                       section.optionalTo
//                                     )
//                                   : 0)}
//                             </td>
//                           </tr>
//                         </React.Fragment>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               </>
//             )}

//             {/* UPLOAD ANSWER */}

//             {/* <ReaderFile /> */}

//             <div className="">
//               {" "}
//               <h3 className="tscr-heading">ANSWER UPLOAD</h3>
//               <div className="tscr-bodies tscr-answer-upload">
//                 <label>Select Set:</label>

//                 <select
//                   className="tscr-setselect"
//                   value={selectedSet}
//                   onChange={handleSetChange}
//                 >
//                   {Array.from({ length: testDetails.numberOfSets }, (_, i) =>
//                     String.fromCharCode(65 + i)
//                   ).map((set) => (
//                     <option key={set} value={set}>
//                       Set {set}
//                     </option>
//                   ))}
//                 </select>

//                 <br />

//                 <br />

//                 <input type="file" onChange={handleFileChange} />

//                 <button
//                   className="tscr-uploadbtn-TSCR"
//                   type="button"
//                   onClick={handleUpload}
//                 >
//                   Upload
//                 </button>

//                 <br />

//                 <br />

//                 {uploadedData.ques_ans_details && currentSetQuestions && (
//                   <>
//                     <h3>Set {selectedSet}</h3>
//                     <div className="tscr-questanskey">
//                       {currentSetQuestions.map((item, index) => (
//                         <div key={index} className="tscr-questanskey-sets">
//                           {item.correct_option.length === 1 &&
//                           item.correct_option[0] === 0 &&
//                           item.numeric_answer !== null
//                             ? `${item.question_no}: ${item.numeric_answer}`
//                             : correctOptionTypeNumeric
//                             ? `${item.question_no}: ${item.correct_option}`
//                             : `${item.question_no}: ${item.correct_option
//                                 .map(
//                                   (option) => reverseAnswerMap[option] || option
//                                 )
//                                 .join(", ")}`}
//                         </div>
//                       ))}
//                     </div>
//                   </>
//                 )}
//               </div>
//             </div>
//           </form>
//         </div>
//       </div>{" "}
//     </>
//   );
// }

// export default TestCreate;






















































import React, { useState, useEffect, useRef } from "react";
import "./TestCreate.css";
import Papa from "papaparse";
import Swal from "sweetalert2";
import { API_BASE_URL } from "../../Config/Config";
import { useLocation } from "react-router-dom";

function TestCreate(dataClient) {
  const location = useLocation();

  // --- STATE ---
  const [courses, setCourses] = useState([]);
  const [isLoadingCourses, setIsLoadingCourses] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(""); // string

  const [testSeries, setTestSeries] = useState([]);
  const [isLoadingSeries, setIsLoadingSeries] = useState(false);
  const [selectedSeries, setSelectedSeries] = useState(""); // string

  const [testDetails, setTestDetails] = useState({
    mode: "",
    testDuration: "",
    questions: "",
    optionalQuestions: "",
    testId: "",
    description: "",
    numberOfSets: 1,
    sections: [],
  });

  const [error, setError] = useState("");
  const [currentSubjectIndex, setCurrentSubjectIndex] = useState(null);
  const [validationErrors, setValidationErrors] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [subjects, setSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [chapters, setChapters] = useState([]);
  const [selectedChapter, setSelectedChapter] = useState(null);
  const [topics, setTopics] = useState([]);
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [allSelections, setAllSelections] = useState([]);
  const [selectedSet, setSelectedSet] = useState("A");
  const [uploadedData, setUploadedData] = useState({});
  const [currentSetQuestions, setCurrentSetQuestions] = useState([]);

  const [file, setFile] = useState(null);
  const [optionalQuestionRanges, setOptionalQuestionRanges] = useState([]);
  const user_name = dataClient.dataClient?.client_schema_name[6][0].user_name;
  const client_id = dataClient.dataClient?.client_schema_name[6][0].client_id;
  const client_branch_id =
    dataClient.dataClient?.client_schema_name[6][0].client_branch_id;

  const [correctOptionTypeNumeric, setCorrectOptionTypeNumeric] =
    useState(false);

  const setMap = { A: "1", B: "2", C: "3", D: "4", E: "5" };

  const answerMap = {
    A: 1,
    B: 2,
    C: 3,
    D: 4,
    E: 5,
    a: 1,
    b: 2,
    c: 3,
    d: 4,
    e: 5,
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
  };

  const reverseAnswerMap = {
    1: "A",
    2: "B",
    3: "C",
    4: "D",
    5: "E",
    0: "0",
  };

  // refs for uncontrolled selects
  const courseSelectRef = useRef(null);
  const seriesSelectRef = useRef(null);

  // small throttle ref used for ignored logs
  const ignoredLogRef = useRef({ lastLogged: 0 });
  const prevCourseRef = useRef("");

  function logIgnoredOnce(message) {
    const now = Date.now();
    if (now - ignoredLogRef.current.lastLogged > 2000) {
      console.log(message);
      ignoredLogRef.current.lastLogged = now;
    }
  }

  // mount log
  useEffect(() => {
    console.log("TestCreate mounted. location:", location.pathname);
  }, [location.pathname]);

  // Fetch courses on mount
  useEffect(() => {
    const url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-courses/`;
    console.log("[fetch] get-courses URL:", url);
    setIsLoadingCourses(true);
    fetch(url)
      .then((res) => {
        console.log("[fetch] get-courses status:", res.status);
        return res.json();
      })
      .then((data) => {
        console.log("[fetch] get-courses data:", data);
        const arr = Array.isArray(data) ? data : data?.courses || data || [];
        setCourses(arr);
      })
      .catch((err) => {
        console.error("[fetch] get-courses error:", err);
        setCourses([]);
      })
      .finally(() => setIsLoadingCourses(false));
  }, []);

  // When selectedCourse changes -> fetch series & subjects
  useEffect(() => {
    console.log("useEffect[selectedCourse] fired. selectedCourse:", selectedCourse);

    // preserve prevCourse
    if (prevCourseRef.current !== selectedCourse) {
      prevCourseRef.current = selectedCourse;
    }

    // reset testDetails when course changes (but don't forcibly re-bind selects)
    setTestDetails((prev) => ({
      ...prev,
      mode: "",
      testDuration: "",
      questions: "",
      optionalQuestions: "",
      testId: "",
      description: "",
      numberOfSets: 1,
      sections: [],
    }));
    setOptionalQuestionRanges([]);

    if (selectedCourse !== "") {
      setIsLoadingSeries(true);
      const courseIdForUrl = encodeURIComponent(selectedCourse);

      const urlSeries = `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-test-series-list-active/?course_id=${courseIdForUrl}`;
      console.log("[fetch] get-test-series-list-active URL:", urlSeries);

      // clear series options but avoid cancelling select interactions — we use uncontrolled select
      setTestSeries([]);

      fetch(urlSeries)
        .then((res) => {
          console.log("[fetch] series status:", res.status, "for course:", selectedCourse);
          return res.json();
        })
        .then((data) => {
          console.log("[fetch] series data:", data);
          const seriesArray = (data && data.test_series) || [];
          setTestSeries(seriesArray);

          // If previously selected series not in new list, clear it after microtask
          if (
            selectedSeries &&
            !seriesArray.some((s) => String(s.ts_id) === String(selectedSeries))
          ) {
            Promise.resolve().then(() => setSelectedSeries(""));
            // also update uncontrolled series select DOM
            if (seriesSelectRef.current) {
              seriesSelectRef.current.value = "";
            }
          }
        })
        .catch((err) => {
          console.error("[fetch] get-test-series-list-active error:", err);
          setTestSeries([]);
          Promise.resolve().then(() => setSelectedSeries(""));
          if (seriesSelectRef.current) seriesSelectRef.current.value = "";
        })
        .finally(() => setIsLoadingSeries(false));

      const urlSubjects = `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-subjects-by-course/?course_id=${courseIdForUrl}`;
      console.log("[fetch] get-subjects-by-course URL:", urlSubjects);
      fetch(urlSubjects)
        .then((res) => {
          console.log("[fetch] subjects status:", res.status, "for course:", selectedCourse);
          return res.json();
        })
        .then((data) => {
          console.log("[fetch] subjects data:", data);
          setSubjects(data || []);
        })
        .catch((err) => {
          console.error("[fetch] get-subjects-by-course error:", err);
          setSubjects([]);
        });
    } else {
      console.log("selectedCourse empty → clearing subjects & series");
      setSubjects([]);
      setTestSeries([]);
      setIsLoadingSeries(false);
      Promise.resolve().then(() => setSelectedSeries(""));
      if (seriesSelectRef.current) seriesSelectRef.current.value = "";
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCourse]);

  // When selectedSeries changes -> fetch series details
  useEffect(() => {
    console.log("useEffect[selectedSeries] fired. selectedSeries:", selectedSeries);
    if (selectedSeries !== "") {
      const tsForUrl = encodeURIComponent(selectedSeries);
      const urlDetails = `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-test-series-details-by-id/?ts_id=${tsForUrl}`;
      console.log("[fetch] get-test-series-details-by-id URL:", urlDetails);
      fetch(urlDetails)
        .then((res) => {
          console.log("[fetch] series-details status:", res.status, "for series:", selectedSeries);
          return res.json();
        })
        .then((data) => {
          console.log("[fetch] series-details data:", data);
          const seriesInfo = data.data || {};

          const optionalQuestionsValue = Array.isArray(seriesInfo.subjects)
            ? seriesInfo.subjects.some((s) => s.optional_total_count > 0)
              ? "Yes"
              : "No"
            : "No";

          setTestDetails({
            mode: seriesInfo.test_mode || "",
            testDuration: seriesInfo.duration_mins || "",
            questions: seriesInfo.total_test_questions || "",
            optionalQuestions: optionalQuestionsValue,
            testId: "",
            description: "",
            numberOfSets: 1,
            sections: (seriesInfo.subjects || []).map((subject) => ({
              subject_id: subject.subject_id,
              subject_name: subject.subject_name,
              mandatory_count: subject.mandatory_count,
              optional_total_count: subject.optional_total_count,
              optional_numeric: subject.optional_numeric,
              from: "",
              to: "",
              optionalFrom: "",
              optionalTo: "",
            })),
          });

          const ranges = (seriesInfo.subjects || [])
            .map((subject) => ({
              subject_id: subject.subject_id,
              optionalFrom: subject.optional_numeric ? subject.optionalFrom : null,
              optionalTo: subject.optional_numeric ? subject.optionalTo : null,
            }))
            .filter((s) => s.optionalFrom && s.optionalTo);
          setOptionalQuestionRanges(ranges);
        })
        .catch((err) => {
          console.error("[fetch] get-test-series-details-by-id error:", err);
          setTestDetails({
            mode: "",
            testDuration: "",
            questions: "",
            optionalQuestions: "",
            testId: "",
            description: "",
            numberOfSets: 1,
            sections: [],
          });
          setOptionalQuestionRanges([]);
        });
    } else {
      console.log("selectedSeries empty → clearing testDetails");
      setTestDetails({
        mode: "",
        testDuration: "",
        questions: "",
        optionalQuestions: "",
        testId: "",
        description: "",
        numberOfSets: 1,
        sections: [],
      });
      setOptionalQuestionRanges([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSeries]);

  // Chapters when subject changes
  useEffect(() => {
    console.log("useEffect[selectedSubject] fired:", selectedSubject);
    if (selectedSubject) {
      const url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-chapters-by-subject/?subject_id=${selectedSubject.subject_id}`;
      console.log("[fetch] get-chapters-by-subject URL:", url);
      fetch(url)
        .then((res) => {
          console.log("[fetch] chapters status:", res.status);
          return res.json();
        })
        .then((data) => {
          console.log("[fetch] chapters data:", data);
          setChapters(data || []);
        })
        .catch((err) => {
          console.error("[fetch] get-chapters-by-subject error:", err);
          setChapters([]);
        });
    } else {
      setChapters([]);
    }
  }, [selectedSubject]);

  // Topics when chapter changes
  useEffect(() => {
    console.log("useEffect[selectedChapter] fired:", selectedChapter);
    if (selectedChapter) {
      const url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-topics-by-chapter/?chapter_id=${selectedChapter.chapter_id}`;
      console.log("[fetch] get-topics-by-chapter URL:", url);
      fetch(url)
        .then((res) => {
          console.log("[fetch] topics status:", res.status);
          return res.json();
        })
        .then((data) => {
          console.log("[fetch] topics data:", data);
          setTopics(data || []);
        })
        .catch((err) => {
          console.error("[fetch] get-topics-by-chapter error:", err);
          setTopics([]);
        });
    } else {
      setTopics([]);
    }
  }, [selectedChapter]);

  // ---------- handlers ----------
  const handleChange = (e, index, key) => {
    const value = e.target.value;
    const input = e.target;
    input.style.border = "";
    if (index !== null) {
      const numericValue = parseInt(value, 10);
      const newSections = [...testDetails.sections];
      newSections[index] = {
        ...newSections[index],
        [key]: numericValue,
      };

      if (key === "to" && testDetails.optionalQuestions === "Yes") {
        const newOptionalFrom = numericValue + 1;
        if (
          !newSections[index].optionalFrom ||
          newSections[index].optionalFrom <= numericValue
        ) {
          newSections[index].optionalFrom = newOptionalFrom;
        }
      }

      setTestDetails((prevDetails) => ({
        ...prevDetails,
        sections: newSections,
      }));

      const section = newSections[index];

      if (
        section.from &&
        section.to &&
        (testDetails.optionalQuestions === "No" ||
          (section.optionalFrom && section.optionalTo))
      ) {
        setError("");
        setCurrentSubjectIndex(null);
      } else {
        setCurrentSubjectIndex(index);
      }
    } else {
      setTestDetails((prevDetails) => ({
        ...prevDetails,
        [key]: value,
      }));
    }
  };

  const handleSubjectChange = (event) => {
    const raw = event.target.value;
    console.log("onChange subject select value:", raw);
    if (raw === "") {
      setSelectedSubject(null);
      setSelectedChapter(null);
      setChapters([]);
      setSelectedTopic(null);
      setTopics([]);
      return;
    }
    const id = parseInt(raw, 10);
    const selected = subjects.find((s) => s.subject_id === id) || null;
    console.log("selectedSubject object:", selected);
    setSelectedSubject(selected);
    setSelectedChapter(null);
    setChapters([]);
    setSelectedTopic(null);
    setTopics([]);
  };

  const handleChapterChange = (event) => {
    const raw = event.target.value;
    console.log("onChange chapter select value:", raw);
    if (raw === "") {
      setSelectedChapter(null);
      setSelectedTopic(null);
      setTopics([]);
      return;
    }
    const id = parseInt(raw, 10);
    const selected = chapters.find((c) => c.chapter_id === id) || null;
    console.log("selectedChapter object:", selected);
    setSelectedChapter(selected);
    setSelectedTopic(null);
    setTopics([]);
  };

  const handleTopicChange = (event) => {
    const raw = event.target.value;
    console.log("onChange topic select value:", raw);
    if (raw === "") {
      setSelectedTopic(null);
      return;
    }
    const id = parseInt(raw, 10);
    const selected = topics.find((t) => t.topic_id === id) || null;
    console.log("selectedTopic object:", selected);
    setSelectedTopic(selected);
  };

  const handleAddSelection = () => {
    console.log("handleAddSelection called with:", {
      selectedSubject,
      selectedChapter,
      selectedTopic,
    });
    const newSelection = {
      subject: selectedSubject,
      chapter: selectedChapter,
      topic: selectedTopic,
    };

    setAllSelections((prev) => [...prev, newSelection]);
    setSelectedChapter(null);
    setChapters([]);
    setSelectedTopic(null);
    setTopics([]);
  };

  const removeSelection = (index, level) => {
    console.log("removeSelection called index:", index, "level:", level);
    const updatedSelections = [...allSelections];

    if (level === "subject") {
      updatedSelections.splice(index, 1);
    } else if (level === "chapter") {
      updatedSelections[index] = {
        ...updatedSelections[index],
        chapter: null,
        topic: null,
      };
    } else if (level === "topic") {
      updatedSelections[index] = { ...updatedSelections[index], topic: null };
    }
    setAllSelections(updatedSelections);
  };

  const handleFileChange = (event) => {
    console.log("file chosen:", event.target.files && event.target.files[0]);
    setFile(event.target.files[0]);
  };

  const handleUpload = () => {
    console.log("handleUpload called. file:", file, "selectedSet:", selectedSet);
    if (!file) {
      console.error("No file selected!");
      return;
    }
    if (!selectedSet) {
      console.error("No set selected!");
      return;
    }

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: function (results) {
        console.log("Papa.parse complete. results:", results);
        if (results.errors.length) {
          console.error("Errors parsing CSV:", results.errors);
          return;
        }

        const data = results.data;
        if (!isNaN(data[0].Key)) {
          setCorrectOptionTypeNumeric(true);
        }

        const formattedData = data.map((item, index) => {
          const keys = Object.keys(item);
          const question = item[keys[0]];
          const correct_ans = item[keys[1]];
          const numeric = item[keys[2]];

          const answers = correct_ans
            ? correct_ans.split(/[,|]/).map((ans) => ans.trim())
            : ["0"];

          let numeric_answer =
            numeric !== undefined && numeric !== null ? numeric : null;

          let correct_option = answers.map((answer) => {
            if (answerMap[answer] !== undefined) {
              return answerMap[answer];
            } else if (!isNaN(answer)) {
              return parseInt(answer, 10); // Ensure number format is handled
            } else {
              return 0;
            }
          });

          if (numeric_answer !== null) {
            numeric_answer = numeric_answer
              .replace(/^0+([1-9])/, "$1")
              .replace(/^0+([.])/, "$1")
              .replace(/^0+(\.\d+)/, "$1");
          }

          if (numeric_answer === null && correct_option.includes(0)) {
            numeric_answer = "0";
          }

          return {
            set: selectedSet,
            question_no: index + 1,
            correct_option:
              correct_option.length > 0 ? correct_option.map(Number) : [0],
            numeric_answer: numeric_answer ? numeric_answer : null,
          };
        });

        console.log("formattedData:", formattedData);

        setUploadedData((prev) => ({
          ...prev,
          [selectedSet]: formattedData,
          ques_ans_details: [
            ...(prev.ques_ans_details || []),
            ...formattedData,
          ],
        }));

        setCurrentSetQuestions(formattedData);
      },
    });
  };

  const handleSetChange = (event) => {
    console.log("set select changed:", event.target.value);
    const newSelectedSet = event.target.value;
    setSelectedSet(newSelectedSet);

    if (uploadedData[newSelectedSet]) {
      setCurrentSetQuestions(uploadedData[newSelectedSet]);
    } else {
      setCurrentSetQuestions([]);
    }
  };

  // Uncontrolled-change handlers: read DOM value via refs to avoid racey re-renders
  const handleCourseSelectChange = (e) => {
    const val = courseSelectRef.current ? courseSelectRef.current.value : e.target.value;
    console.log("course select onChange (uncontrolled) value:", val);
    if (val === "" && courses.length > 0) {
      logIgnoredOnce("Ignored spurious empty course change (uncontrolled).");
      return;
    }
    setSelectedCourse(val);
  };

  const handleSeriesSelectChange = (e) => {
    const val = seriesSelectRef.current ? seriesSelectRef.current.value : e.target.value;
    console.log("series select onChange (uncontrolled) value:", val);
    if (val === "" && testSeries.length > 0) {
      logIgnoredOnce("Ignored spurious empty series change (uncontrolled).");
      return;
    }
    setSelectedSeries(val);
  };

  const calculateTotal = (from, to) => {
    if (!from || !to) return 0; // Return 0 if either value is null, undefined, or 0
    return Math.max(0, (parseInt(to, 10) || 0) - (parseInt(from, 10) || 0) + 1);
  };

  const getMinValue = (index, key) => {
    if (key === "to" && testDetails.sections[index].from) {
      return parseInt(testDetails.sections[index].from, 10) + 1;
    }

    if (key === "optionalFrom" && testDetails.sections[index].to) {
      return parseInt(testDetails.sections[index].to, 10) + 1;
    }

    if (key === "optionalTo" && testDetails.sections[index].optionalFrom) {
      return parseInt(testDetails.sections[index].optionalFrom, 10) + 1;
    }

    return 0;
  };

  const validateSections = (sections) => {
    let errors = [];
    let totalQuestionsCount = 0;

    sections.forEach((section, index) => {
      // Skip subjects with no questions defined
      if (!section.from && !section.to && !section.optionalFrom && !section.optionalTo) {
        return;
      }

      const totalSectionA = calculateTotal(section.from, section.to);
      const totalSectionB =
        testDetails.optionalQuestions === "Yes"
          ? calculateTotal(section.optionalFrom, section.optionalTo)
          : 0;

      totalQuestionsCount += totalSectionA + totalSectionB;

      if (totalSectionA !== section.mandatory_count) {
        errors.push({
          subjectName: section.subject_name,
          message: `Total Section A value should be ${section.mandatory_count} for ${section.subject_name}`,
          field: `sectionA-${index}`,
        });
      }

      if (totalSectionB !== section.optional_total_count) {
        errors.push({
          subjectName: section.subject_name,
          message: `Total Section B value should be ${section.optional_total_count} for ${section.subject_name}`,
          field: `sectionB-${index}`,
        });
      }
    });

    if (totalQuestionsCount !== parseInt(testDetails.questions, 10)) {
      errors.push({
        message: `The sum of all Total A + B (${totalQuestionsCount}) must equal the Total Questions (${testDetails.questions}).`,
      });
    }

    console.log("validateSections errors:", errors);
    setValidationErrors(errors);
    setError(errors.length > 0 ? errors[0].message : "");
  };

  // Full handleCreate (kept consistent with your original logic)
  const handleCreate = async (e) => {
    e.preventDefault();

    if (!testDetails.testId) {
      Swal.fire({
        title: "Error",
        text: "Enter Test Name",
        icon: "error",
        confirmButtonColor: "rgb(100 101 101)",
      });

      return;
    }

    if (!testDetails.description) {
      Swal.fire({
        title: "Error",
        text: "Enter Description",
        icon: "error",
        confirmButtonColor: "rgb(100 101 101)",
      });
      return;
    }

    if (
      Object.keys(uploadedData).length === 0 ||
      !uploadedData.ques_ans_details
    ) {
      Swal.fire({
        title: "Error",
        text: "Upload the answer key file",
        icon: "error",
        confirmButtonColor: "rgb(100 101 101)",
      });
      return;
    }

    const totalQuestions = parseInt(testDetails.questions, 10);

    const sets = Object.keys(uploadedData).filter(
      (key) => key !== "ques_ans_details"
    );

    for (let set of sets) {
      if (uploadedData[set].length !== totalQuestions) {
        Swal.fire({
          title: "Error",
          text: "No of questions in answer key does not match Total Questions",
          icon: "error",
          confirmButtonColor: "rgb(100 101 101)",
        });
        return;
      }
    }

    const expectedSets = Array.from(
      { length: testDetails.numberOfSets },
      (_, i) => String.fromCharCode(65 + i)
    );

    const missingSets = expectedSets.filter(
      (set) => !uploadedData.hasOwnProperty(set)
    );

    if (missingSets.length > 0) {
      Swal.fire({
        title: "Error",
        text: `Upload answer key files for the following sets: ${missingSets.join(
          ", "
        )}`,
        icon: "error",
        confirmButtonColor: "rgb(100 101 101)",
      });
      return;
    }

    setSubmitted(true);

    let pairs = [];

    testDetails.sections.forEach((section, index) => {
      if (section.from && section.to) {
        pairs.push({
          from: section.from,
          to: section.to,
          fieldFrom: document.querySelector(`#subject-${index} .from`),
          fieldTo: document.querySelector(`#subject-${index} .to`),
        });
      }

      if (
        section.optionalFrom &&
        section.optionalTo &&
        testDetails.optionalQuestions === "Yes"
      ) {
        pairs.push({
          from: section.optionalFrom,
          to: section.optionalTo,
          fieldFrom: document.querySelector(`#subject-${index} .optionalFrom`),
          fieldTo: document.querySelector(`#subject-${index} .optionalTo`),
        });
      }
    });

    pairs.sort((a, b) => a.from - b.from);

    let validPairs = true;

    for (let i = 0; i < pairs.length - 1; i++) {
      const currentTo = pairs[i].to;
      const nextFrom = pairs[i + 1].from;
      if (nextFrom - currentTo !== 1) {
        validPairs = false;
        pairs[i + 1].fieldFrom.style.border = "2px solid red";
      }
    }

    if (!validPairs) {
      setError("The difference between consecutive pairs should be 1.");
      return;
    } else {
      setError("");
    }

    const sectionsWithTotals = testDetails.sections.map((section) => ({
      ...section,
      totalSectionA: calculateTotal(section.from, section.to),
      totalSectionB:
        testDetails.optionalQuestions === "Yes"
          ? calculateTotal(section.optionalFrom, section.optionalTo)
          : 0,
    }));

    validateSections(sectionsWithTotals);
    if (validationErrors.length > 0) {
      return;
    }

    const totalQuestionsFromSections = sectionsWithTotals.reduce(
      (acc, section) => acc + section.totalSectionA + section.totalSectionB,
      0
    );

    if (totalQuestionsFromSections !== parseInt(testDetails.questions, 10)) {
      setError(
        `The sum of all Total A + B (${totalQuestionsFromSections}) must equal the Total Questions (${testDetails.questions}).`
      );
      return;
    }

    const subjectTopicDetails = allSelections.map((selection) => ({
      subject_id: selection.subject.subject_id,
      chapter_id: selection.chapter ? selection.chapter.chapter_id : 0,
      topic_id: selection.topic ? selection.topic.topic_id : 0,
      subtopic_id: null,
    }));

    const prepareSubjectQuestionDetails = (sections) => {
      return sections.map((section) => ({
        subject_id: section.subject_id,
        mandatory_from: section.from ? parseInt(section.from, 10) : 0,
        mandatory_to: section.to ? parseInt(section.to, 10) : 0,
        optional_from: section.optionalFrom ? parseInt(section.optionalFrom, 10) : 0,
        optional_to: section.optionalTo ? parseInt(section.optionalTo, 10) : 0,
      }));
    };

    const subjectQuestionDetails = prepareSubjectQuestionDetails(testDetails.sections);

    let quesAnsDetails = [];

    for (let set in uploadedData) {
      if (set !== "ques_ans_details") {
        const setData = uploadedData[set].map((item) => ({
          set: setMap[set],
          question_no: parseInt(item.question_no),
          correct_option: item.correct_option,
          numeric_answer: item.numeric_answer,
        }));
        quesAnsDetails = quesAnsDetails.concat(setData);
      }
    }

    const outputData = {
      subject_topic_details: subjectTopicDetails,
      subject_question_details: subjectQuestionDetails,
      ques_ans_details: quesAnsDetails,
    };

    console.log("Prepared POST body:", outputData);

    const url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/create-test?assessment_name=${encodeURIComponent(
      testDetails.testId
    )}&course_id=${encodeURIComponent(selectedCourse)}&ts_id=${encodeURIComponent(selectedSeries)}&no_of_sets=${testDetails.numberOfSets}&user_name=${encodeURIComponent(
      user_name
    )}&client_id=${client_id}&client_branch_id=${client_branch_id}&assessment_desc=${encodeURIComponent(
      testDetails.description
    )}`;

    console.log("[fetch] create-test URL:", url);

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(outputData),
      });

      console.log("create-test response status:", response.status);
      const data = await response.json();
      console.log("create-test response data:", data);

      if (response.ok) {
        Swal.fire({
          title: "Test created successfully",
          icon: "success",
          timer: 2000,
          confirmButtonColor: "#318682",
        }).then(() => {
          setTimeout(() => {
            window.location.reload();
          }, 100);
        });
      } else {
        Swal.fire({
          title: "Error in creating test",
          text: data.message,
          icon: "error",
          confirmButtonColor: "rgb(100 101 101)",
        });
      }
    } catch (error) {
      console.error("Error creating test (create-test):", error);

      Swal.fire({
        title: "Error in creating test",
        text: `${error.message}`,
        icon: "error",
        confirmButtonColor: "rgb(100 101 101)",
      });
    }
  };

  const handleCancel = () => {
    Swal.fire({
      title: "Are you sure you want to cancel?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: "rgb(100 101 101)",
      cancelButtonColor: "#318682",
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload();
      }
    });
  };

  // minimal render debug (not spammy)
  useEffect(() => {
    console.log(
      "render debug: selectedCourse=",
      selectedCourse,
      "selectedSeries=",
      selectedSeries,
      "courses.len=",
      courses.length,
      "series.len=",
      testSeries.length,
      "isLoadingSeries=",
      isLoadingSeries
    );
  }); // no deps on purpose for lightweight occasional debugging

  // ---------- RENDER ----------
  return (
    <>
      <div className="create-role-container">
        <div className="create-role-container-one">
          <span className="create-role-heading">Create Test</span>

          <div className="cr-header-btn-container">
            <button className="cr-cancel-btn" onClick={handleCancel}>
              CANCEL
            </button>

            <button className="cr-create-btn" onClick={handleCreate}>
              CREATE
            </button>
          </div>
        </div>

        <div className="create-role-container-two">
          <form>
            <h3 className="tscr-heading">TEST PARTICULARS</h3>

            <div className="tscr-bodies tscr-grid-container">
              <label className="tscr-grid-item">Course:</label>

              <select
                name="course"
                ref={courseSelectRef}
                defaultValue={selectedCourse || ""}
                onChange={handleCourseSelectChange}
                disabled={isLoadingCourses}
                className="tscr-grid-item"
              >
                <option value="">Select a course</option>
                {isLoadingCourses && (
                  <option value="" disabled>
                    Loading courses...
                  </option>
                )}
                {courses.map((course) => (
                  <option key={course.course_id} value={String(course.course_id)}>
                    {course.course_name}
                  </option>
                ))}
              </select>

              <label className="tscr-grid-item">Test Series:</label>

              <select
                name="testSeries"
                ref={seriesSelectRef}
                defaultValue={selectedSeries || ""}
                onChange={handleSeriesSelectChange}
                disabled={
                  selectedCourse === "" || isLoadingSeries || testSeries.length === 0
                }
                className="tscr-grid-item"
              >
                <option value="">Select a series</option>
                {isLoadingSeries && (
                  <option value="" disabled>
                    Loading series...
                  </option>
                )}
                {testSeries.map((series) => (
                  <option key={series.ts_id} value={String(series.ts_id)}>
                    {series.ts_name}
                  </option>
                ))}
              </select>

              <label className="tscr-grid-item">Mode:</label>

              <input
                className="tscr-grid-item"
                name="mode"
                value={testDetails.mode}
                readOnly
                style={{ backgroundColor: "lightgray", border: "none" }}
              />

              <label className="tscr-grid-item">Test Duration (mins):</label>

              <input
                className="tscr-grid-item"
                name="testDuration"
                value={testDetails.testDuration}
                readOnly
                style={{ backgroundColor: "lightgray", border: "none" }}
              />

              <label className="tscr-grid-item">Total Questions:</label>

              <input
                className="tscr-grid-item"
                name="questions"
                value={testDetails.questions}
                readOnly
                style={{ backgroundColor: "lightgray", border: "none" }}
              />

              <label className="tscr-grid-item">Optional Questions:</label>

              <input
                className="tscr-grid-item"
                name="optionalQuestions"
                value={testDetails.optionalQuestions}
                readOnly
                style={{ backgroundColor: "lightgray", border: "none" }}
              />

              <label className="tscr-grid-item">Test Name:</label>

              <input
                className="tscr-grid-item"
                name="testId"
                type="text"
                value={testDetails.testId}
                onChange={(e) => {
                  setTestDetails((prevDetails) => ({
                    ...prevDetails,
                    testId: e.target.value, // Update state with the raw value (including spaces)
                  }));
                }}
                onBlur={(e) => {
                  const trimmedValue = e.target.value.trim();
                  setTestDetails((prevDetails) => ({
                    ...prevDetails,
                    testId: trimmedValue,
                  }));
                }}
              />

              <label className="tscr-grid-item">Description:</label>

              <input
                className="tscr-grid-item"
                name="description"
                value={testDetails.description}
                onChange={(e) => handleChange(e, null, "description")}
              />

              <label className="tscr-grid-item">Number of Sets:</label>

              <select
                className="tscr-grid-item"
                name="numberOfSets"
                value={testDetails.numberOfSets}
                onChange={(e) => handleChange(e, null, "numberOfSets")}
              >
                {[1, 2, 3, 4, 5].map((num) => (
                  <option key={num} value={num}>
                    {num}
                  </option>
                ))}
              </select>
            </div>

            {/* SUBJECT TAGGING */}

            <div>
              <h3 className="tscr-heading">TEST PAPER TAGGING</h3>

              <div className="tpt-container tscr-bodies">
                <div className="tpt-dropdowns">
                  <div className="tpt-dropdowns-content">
                    <label>
                      <label className="categoryname-TSCR">Subject:</label>

                      <select
                        value={
                          selectedSubject ? selectedSubject.subject_id : ""
                        }
                        onChange={handleSubjectChange}
                        disabled={!selectedCourse}
                      >
                        <option value="">Select Subject</option>

                        {subjects.map((subject) => (
                          <option
                            key={subject.subject_id}
                            value={subject.subject_id}
                          >
                            {subject.subject_name}
                          </option>
                        ))}
                      </select>
                    </label>

                    <label>
                      <label className="categoryname-TSCR"> Chapter:</label>

                      <select
                        value={
                          selectedChapter ? selectedChapter.chapter_id : ""
                        }
                        onChange={handleChapterChange}
                        disabled={!selectedSubject}
                      >
                        <option value="">Select Chapter</option>

                        {selectedSubject &&
                          chapters.map((chapter) => (
                            <option
                              key={chapter.chapter_id}
                              value={chapter.chapter_id}
                            >
                              {chapter.chapter_name}
                            </option>
                          ))}
                      </select>
                    </label>

                    <label>
                      <label className="categoryname-TSCR"> Topic:</label>

                      <select
                        value={selectedTopic ? selectedTopic.topic_id : ""}
                        onChange={handleTopicChange}
                        disabled={!selectedChapter}
                      >
                        <option value="">Select Topic</option>

                        {selectedChapter &&
                          topics.map((topic) => (
                            <option key={topic.topic_id} value={topic.topic_id}>
                              {topic.topic_name}
                            </option>
                          ))}
                      </select>
                    </label>

                    <div className="tpt-addbtn-cont">
                      <button
                        type="button"
                        onClick={handleAddSelection}
                        disabled={!selectedChapter}
                        className="tscr-Add-TSCR"
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>

                <div className="tpt-tags">
                  <h4>Selections</h4>

                  {allSelections.map((selection, index) => (
                    <div key={index}>
                      {selection.subject.subject_name}

                      <button
                        type="button"
                        onClick={() => removeSelection(index, "subject")}
                      >
                        &#x2716;
                      </button>

                      {selection.chapter && (
                        <>
                          <span style={{ fontSize: "20px" }}>
                            &#x276F;
                          </span>{" "}
                          {selection.chapter.chapter_name}
                          <button
                            type="button"
                            onClick={() => removeSelection(index, "chapter")}
                          >
                            &#x2716;
                          </button>
                        </>
                      )}

                      {selection.topic && (
                        <>
                          <span style={{ fontSize: "20px" }}>
                            &#x276F;
                          </span>{" "}
                          {selection.topic.topic_name}
                          <button
                            type="button"
                            onClick={() => removeSelection(index, "topic")}
                          >
                            &#x2716;
                          </button>
                        </>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {selectedSeries && (
              <>
                <h3 className="tscr-heading">TEST PAPER STRUCTURE</h3>

                <div className="tscr-testpaperstr tscr-bodies">
                  {submitted && error && (
                    <div style={{ color: "red", marginBottom: "10px" }}>
                      {error}
                    </div>
                  )}

                  <table>
                    <thead>
                      <tr>
                        <th colSpan="1">{""}</th>
                        <th colSpan="3">Mandatory Q (Section A)</th>
                        <th colSpan="3">Optional Q (Section B)</th>
                        <th colSpan="1">Total</th>
                      </tr>

                      <tr>
                        <td>Subject</td>
                        <td>From</td>
                        <td>To</td>
                        <td>Total Section A</td>
                        <td>Optional From</td>
                        <td>Optional To</td>
                        <td>Total Section B</td>
                        <td>Total A + B</td>
                      </tr>
                    </thead>

                    <tbody>
                      {testDetails.sections.map((section, index) => (
                        <React.Fragment key={index}>
                          <tr id={`subject-${index}`}>
                            <td>{section.subject_name}</td>

                            <td>
                              <input
                                className="from"
                                value={section.from}
                                onChange={(e) => handleChange(e, index, "from")}
                                type="number"
                                min={getMinValue(index, "from")}
                                disabled={
                                  currentSubjectIndex !== null &&
                                  currentSubjectIndex !== index
                                }
                              />
                            </td>

                            <td>
                              <input
                                className="to"
                                value={section.to}
                                onChange={(e) => handleChange(e, index, "to")}
                                type="number"
                                min={getMinValue(index, "to")}
                                disabled={
                                  currentSubjectIndex !== null &&
                                  currentSubjectIndex !== index
                                }
                              />
                            </td>

                            <td>
                              <div
                                className={
                                  submitted &&
                                  validationErrors.some(
                                    (error) =>
                                      error.field === `sectionA-${index}`
                                  )
                                    ? "tscr-error"
                                    : ""
                                }
                              >
                                {section.from && section.to
                                  ? calculateTotal(section.from, section.to)
                                  : 0}
                              </div>
                            </td>

                            <td>
                              <input
                                className="optionalFrom"
                                value={section.optionalFrom}
                                onChange={(e) =>
                                  handleChange(e, index, "optionalFrom")
                                }
                                type="number"
                                min={getMinValue(index, "optionalFrom")}
                                disabled={
                                  testDetails.optionalQuestions === "No" ||
                                  (currentSubjectIndex !== null &&
                                    currentSubjectIndex !== index)
                                }
                              />
                            </td>

                            <td>
                              <input
                                className="optionalTo"
                                value={section.optionalTo}
                                onChange={(e) =>
                                  handleChange(e, index, "optionalTo")
                                }
                                type="number"
                                min={getMinValue(index, "optionalTo")}
                                disabled={
                                  testDetails.optionalQuestions === "No" ||
                                  (currentSubjectIndex !== null &&
                                    currentSubjectIndex !== index)
                                }
                              />
                            </td>

                            <td>
                              <div
                                className={
                                  submitted &&
                                  validationErrors.some(
                                    (error) =>
                                      error.field === `sectionB-${index}`
                                  )
                                    ? "tscr-error"
                                    : ""
                                }
                              >
                                {section.optionalFrom && section.optionalTo
                                  ? calculateTotal(
                                      section.optionalFrom,

                                      section.optionalTo
                                    )
                                  : 0}
                              </div>
                            </td>

                            <td>
                              {(section.from && section.to
                                ? calculateTotal(section.from, section.to)
                                : 0) +
                                (section.optionalFrom && section.optionalTo
                                  ? calculateTotal(
                                      section.optionalFrom,

                                      section.optionalTo
                                    )
                                  : 0)}
                            </td>
                          </tr>
                        </React.Fragment>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            )}

            {/* UPLOAD ANSWER */}
            <div className="">
              <h3 className="tscr-heading">ANSWER UPLOAD</h3>
              <div className="tscr-bodies tscr-answer-upload">
                <label>Select Set:</label>

                <select
                  className="tscr-setselect"
                  value={selectedSet}
                  onChange={handleSetChange}
                >
                  {Array.from({ length: testDetails.numberOfSets }, (_, i) =>
                    String.fromCharCode(65 + i)
                  ).map((set) => (
                    <option key={set} value={set}>
                      Set {set}
                    </option>
                  ))}
                </select>

                <br />
                <br />

                <input type="file" onChange={handleFileChange} />

                <button
                  className="tscr-uploadbtn-TSCR"
                  type="button"
                  onClick={handleUpload}
                >
                  Upload
                </button>

                <br />
                <br />

                {uploadedData.ques_ans_details && currentSetQuestions && (
                  <>
                    <h3>Set {selectedSet}</h3>
                    <div className="tscr-questanskey">
                      {currentSetQuestions.map((item, index) => (
                        <div key={index} className="tscr-questanskey-sets">
                          {item.correct_option.length === 1 &&
                          item.correct_option[0] === 0 &&
                          item.numeric_answer !== null
                            ? `${item.question_no}: ${item.numeric_answer}`
                            : correctOptionTypeNumeric
                            ? `${item.question_no}: ${item.correct_option}`
                            : `${item.question_no}: ${item.correct_option
                                .map(
                                  (option) => reverseAnswerMap[option] || option
                                )
                                .join(", ")}`}
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default TestCreate;
